$(() => {
    // console.log('template active');
});
